import axiosInstance from "../../../api/axiosConfig";

export const changePassword = (data: any) => {
  return axiosInstance.post("/auth/change-password", data);
};
